import React from "react";
import { Fade } from "react-awesome-reveal";
import Whats from "./Whats";
import "../styles/Services.scss";
import img1 from "../images/services/1.png";
import img2 from "../images/services/2.png";
import img3 from "../images/services/3.png";
import img4 from "../images/services/4.png";
import img5 from "../images/services/5.png";

const Services = () => {
  const servicios = [
    {
      id: 1,
      imagen: img1,
      titulo: "Instalación de Pisos Epóxicos",
      texto:
        'En Recubrimiento Epóxico de Mexicali, nos especializamos en la instalación de pisos epóxicos para hogares. Evaluamos y preparamos adecuadamente la superficie, utilizando productos de alta calidad y técnicas avanzadas para un acabado resistente y estético. Ideales para áreas de alto tráfico como cocinas, garajes y patios, los pisos epóxicos son resistentes a impactos y químicos, además de ser fáciles de limpiar y mantener. Nuestro equipo experto se encarga de todo el proceso, ofreciendo una variedad de colores y acabados para personalizar tus pisos. Confía en nosotros para transformar tus espacios con pisos epóxicos duraderos y de alta calidad.',
    },
    {
      id: 2,
      imagen: img2,
      titulo: "Encimeras y Superficies Epóxicas",
      texto:
        "Transformamos tus encimeras y superficies con recubrimientos epóxicos de alta calidad. Ideales para cocinas y baños, nuestras soluciones son resistentes, estéticas y fáciles de mantener. Utilizamos materiales premium para crear acabados personalizados que imitan piedra, mármol o diseños únicos. Las encimeras epóxicas son duraderas, resistentes a manchas, impactos y calor. Confía en nuestro equipo experto para renovar tus espacios con encimeras epóxicas que combinan funcionalidad y diseño innovador.",
    },
    {
      id: 3,
      imagen: img3,
      titulo: "Proyectos Residenciales",
      texto:
        "Nos especializamos en transformar hogares con recubrimientos epóxicos de alta calidad. Ofrecemos soluciones personalizadas para pisos, encimeras y paredes, adaptándonos a tus necesidades y estilo. Utilizamos materiales duraderos y técnicas avanzadas para garantizar acabados resistentes y estéticos. Ya sea que busques modernizar tu cocina, baño u otro espacio, te brindamos resultados funcionales y atractivos. Confía en nosotros para llevar a cabo tus proyectos residenciales con profesionalismo y dedicación, asegurando tu satisfacción en cada etapa.",
    },
    {
      id: 4,
      imagen: img4,
      titulo: "Diferentes Estilos",
      texto:
        "Ofrecemos una variedad de recubrimientos epóxicos para adaptarse a tus gustos. Desde acabados metálicos y marmoleados hasta diseños personalizados que imitan el estilo granito con puntitos, creando una apariencia única y moderna. Nuestros productos garantizan resultados duraderos y estéticamente atractivos. Transforma tus pisos, encimeras o paredes con recubrimientos que combinan funcionalidad y elegancia.",
    },
    {
      id: 5,
      imagen: img5,
      titulo: "Restauración y Mantenimiento ",
      texto:
        "Ofrecemos servicios de restauración y mantenimiento para recubrimientos epóxicos, asegurando que tus superficies sigan luciendo como nuevas. Nos encargamos de reparar daños, mantener el acabado y prolongar la durabilidad de tus pisos, encimeras o paredes. Nuestro equipo utiliza técnicas especializadas para restaurar la apariencia y funcionalidad de tus recubrimientos, garantizando resultados de alta calidad. Confía en nosotros para mantener tus espacios impecables a lo largo del tiempo.",
    },
  ];

  return (
    <div id="allServices">
      <h4 className="fw-bold title">NUESTROS SERVICIOS</h4>
      {servicios.map((servicio) => (
        <section
          className="cursosContainer"
          id={"servicio" + servicio.id}
          key={servicio.id}
        >
          <div className="imgContainer text-center">
            <Fade duration="1000">
              <img src={servicio.imagen} alt={servicio.titulo} />
            </Fade>
          </div>
          <div className="infoCursoContainer">
            <Fade duration="1000">
              <span className="titleService">
                <strong>{servicio.titulo}</strong>
              </span>
            </Fade>
            <span className="textService">{servicio.texto}</span>

            <div className="btnServiceContainer">
              <Whats
                classStyle="btn btnService"
                phoneNumber="5216866054231"
                message={`¡Me pudiera brindar más información acerca de ${servicio.titulo}!`}
                text="¡Más información!"
              />
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default Services;
